import { render, staticRenderFns } from "./DeleteLinkPopup.vue?vue&type=template&id=a6937030&scoped=true&"
import script from "./DeleteLinkPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteLinkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLinkPopup.vue?vue&type=style&index=0&id=a6937030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6937030",
  null
  
)

export default component.exports